import * as React from "react"
import type { SVGProps } from "react"
const SvgWordPress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 512 512"
    {...props}
  >
    <rect width={512} height={512} fill="currentColor" rx="15%" />
    <circle
      cx={256}
      cy={256}
      r={190}
      fill="none"
      stroke="#fff"
      strokeWidth={20}
    />
    <path
      fill="#fff"
      d="m204 436 56-164 58 159 29-16 56-162c10-26 13-47 13-65 1-33-13-62-37-65-22-2-34 19-33 32 2 30 32 47 32 88 0 30-19 77-32 122l-65-194c11-1 21-1 21-1 10-1 9-16-1-15-33 3-63 2-96 0-10-1-11 14-1 15 0 0 9 0 19 1l28 77-40 119-65-196c11-1 20-1 20-1 10-1 9-16-1-15-30 2-59 4-66-1l-9 25 88 243z"
    />
  </svg>
)
export default SvgWordPress
